import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcomeExchange = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 24,
	viewBox: "0 0 32 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M25.0299 3.82176L10.5726 3.82176L10.5726 8.59893L25.0299 8.59894L25.0299 12.4207L31.7179 6.21033L25.0299 3.03342e-06L25.0299 3.82176Z",
		fill: "#FF3131"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.68802 20.1782L21.1453 20.1782L21.1453 15.4011L6.68802 15.4011L6.68802 11.5793L-3.65111e-05 17.7897L6.688 24L6.68802 20.1782Z",
		fill: "#A3B8C2"
	})]
});
export default SvgWelcomeExchange;
